export default __webpack_public_path__ + "static/media/transpaleta5.30ccd856.jpg";